import React from 'react';
import work from '../../images/Work.jpg';

function Header() {
  return (
    <div id="headerSection" className="header-div">
      <div className="header-text">
        <div className="header-name">
          Hi, I'm Swapnil.
        </div>
        <div className="header-intro">
          I have a keen interest in all things web.
        </div>
      </div>
      <div className="header-image-div">
        <img src={work} alt="work" className="header-image" />
      </div>
    </div>
  )
}

export default Header;